import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import PlaylistAccordion from "./PlaylistAccordion";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import {
  makeBackendAPIRequest,
  backendBaseURL,
} from "../api_utilities/backend";
import Snackbar from "@material-ui/core/Snackbar";
import { Alert } from "@material-ui/lab";
import { makeSpotifyAPIRequest } from "../api_utilities/spotify";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";

const useStyles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    height: "100%",
  },
  spaceBelow: {
    marginBottom: theme.spacing(2),
  },
});

class PlaylistList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      backendPlaylists: [],
      snackbarMessage: "",
      isSnackbarOpen: false,
      snackbarSeverity: "success",
    };
  }

  componentDidMount() {
    this.getBackendPlaylists();
  }

  getBackendPlaylists = () => {
    const url = new URL(backendBaseURL + "/playlist/get_playlists");
    makeBackendAPIRequest({
      url: url,
      method: "GET",
      onSuccessCallback: (data) => {
        this.setState({ backendPlaylists: data });
      },
      onFailureCallback: () => {},
    });
  };

  createPlaylist = () => {
    const url = new URL(
      `https://api.spotify.com/v1/users/${localStorage.getItem(
        "spotify_user_id"
      )}/playlists`
    );

    makeSpotifyAPIRequest({
      url: url,
      method: "POST",
      body: {
        name: "New Playlist",
        public: false,
        description: "Created by Snobify",
      },
      onSuccessCallback: (data) => {
        const url = new URL(backendBaseURL + "/playlist/create_playlist");
        makeBackendAPIRequest({
          url: url,
          method: "POST",
          body: {
            id_spotify: data.id,
            name: data.name,
          },
          onSuccessCallback: (backendPlaylist) => {
            this.setState((prevState) => {
              return {
                backendPlaylists: [backendPlaylist].concat(
                  prevState.backendPlaylists
                ),
                isSnackbarOpen: true,
                snackbarSeverity: "success",
                snackbarMessage: "Playlist succesfully created.",
              };
            });
          },
          onFailureCallback: () => {},
        });
      },
      onFailureCallback: () => {},
    });
  };

  deletePlaylist = (id) => {
    this.setState((prevState) => {
      return {
        backendPlaylists: prevState.backendPlaylists.filter(
          (playlist) => playlist.id_spotify !== id
        ),
      };
    });

    let url = new URL(backendBaseURL + "/playlist/delete_playlist");
    makeBackendAPIRequest({
      url: url,
      method: "POST",
      body: {
        id_spotify: id,
      },
      onSuccessCallback: () => {
        this.setState({
          isSnackbarOpen: true,
          snackbarMessage:
            "Playlist successfully deleted, but due to API limitations, you must also remove it from Spotify manually.",
          snackbarSeverity: "warning",
        });
      },
      onFailureCallback: () => {},
    });
  };

  render() {
    const { classes } = this.props;
    const {
      backendPlaylists,
      isSnackbarOpen,
      snackbarMessage,
      snackbarSeverity,
    } = this.state;

    return (
      <Card className={classes.root}>
        <Grid container spacing={3}>
          <Grid
            item
            container
            xs={6}
            justify={"flex-start"}
            className={classes.spaceBelow}
          >
            <Fab color="primary" onClick={this.createPlaylist}>
              <AddIcon />
            </Fab>
          </Grid>
          <Grid
            item
            container
            xs={6}
            justify={"flex-end"}
            className={classes.spaceBelow}
          >
            <Typography variant="overline">Auto Playlist Builder</Typography>
          </Grid>
          {backendPlaylists.map((playlist) => (
            <Grid item xs={12} key={playlist.id_spotify}>
              <PlaylistAccordion
                id={playlist.id_spotify}
                name={playlist.name}
                rules={playlist.rules}
                handleDelete={this.deletePlaylist}
              />
            </Grid>
          ))}
        </Grid>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          open={isSnackbarOpen}
          autoHideDuration={snackbarMessage.length * 150}
          onClose={() => {
            this.setState({ isSnackbarOpen: false });
          }}
        >
          <Alert
            onClose={() => {
              this.setState({ isSnackbarOpen: false });
            }}
            severity={snackbarSeverity}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Card>
    );
  }
}

export default withStyles(useStyles)(PlaylistList);
